import { useQuery } from '@tanstack/react-query'
import {
  ShiftNoticeMetrics,
  getShiftNoticeMetrics,
} from 'api/pulse/shiftNoticeMetrics'
import { PulseFilters } from 'api/pulse'
import { getShiftNoticeMetricsKey } from './keys'
import { PULSE_QUERY_OPTIONS } from './constants'

export function useShiftNoticeMetrics(query: PulseFilters) {
  return useQuery<ShiftNoticeMetrics>({
    ...PULSE_QUERY_OPTIONS,
    queryKey: getShiftNoticeMetricsKey(query),
    queryFn: ({ signal }) => getShiftNoticeMetrics(query, signal),
    enabled: !!query.companyIds?.length,
  })
}
